import { useState } from 'react';
import delay from '../../pages/utils/delay';
import { CHAPTER_ENTRIES } from '../../chapterRegistry';

import './chapter-selection-modal.scss';

const ChapterSelectionModal = ({ currentPageName, onClose, setChapterComplete, setIsTransitioning, goToPage }) => {
  const [overlayClass, setOverlayClass] = useState('csm-overlay');

  const handleClose = () => {
    setOverlayClass('csm-overlay csm-overlay--closed');
    onClose();
  };

  const handleChapterClick = async (key) => {
    setIsTransitioning(true);
    await delay(1000);
    setChapterComplete(true);
    onClose();
    goToPage(key);
  };

  return (
    <div className={overlayClass}>
      <div className="csm-modal">
        <h2 className="csm-title">Selecione um capítulo</h2>
        <div className="csm-chapters">
          {CHAPTER_ENTRIES.map(({ label, key }) => (
            <button
              key={key}
              className={key === currentPageName ? 'csm-chapter-button is-current' : 'csm-chapter-button'}
              onClick={() => handleChapterClick(key)}
            >
              {label}
            </button>
          ))}
        </div>
        <button className="csm-close-button" onClick={handleClose}>fechar</button>
      </div>
    </div>
  );
};

export default ChapterSelectionModal;
